export default "__VITE_ASSET__C$yMBXVu__"